import { useObjectUrl } from '@vueuse/core'

import type { ComputedRef } from 'vue'
import type { OrderInvoicePreviewState } from './types'

import { useOrderInvoiceStore } from './store'

const PDF_VIEW_PARAMETERS = 'navpanes=0&view=FitH'

const STATE_LABELS: Record<OrderInvoicePreviewState, string> = {
  automatic: 'Automatic invoice',
  saved: 'Last saved version',
  unsaved: 'Not saved',
}

interface OrderInvoicePreviewFrameReturn {
  frameUrl: ComputedRef<string | undefined>
  stateLabel: ComputedRef<string>
  isUnsaved: ComputedRef<boolean>
  isLoading: ComputedRef<boolean>
}

export const useOrderInvoicePreviewFrame = (): OrderInvoicePreviewFrameReturn => {
  const store = useOrderInvoiceStore()

  const preview = computed<Blob | null>(() => store.getPreview)
  const objectUrl = useObjectUrl(preview)
  const frameUrl = computed<string | undefined>(() =>
    objectUrl.value ? `${objectUrl.value}#${PDF_VIEW_PARAMETERS}` : undefined,
  )

  const stateLabel = computed<string>(() => STATE_LABELS[store.getPreviewState])
  const isUnsaved = computed<boolean>(() => store.getPreviewState === 'unsaved')
  const isLoading = computed<boolean>(() => store.isLoading || store.isPreviewLoading)

  return {
    frameUrl,
    stateLabel,
    isUnsaved,
    isLoading,
  }
}
